import { Helmet } from "react-helmet-async";
import { HeadProps } from "./types";

export const Head = ({ colorScheme = "light" }: HeadProps) => {
  return (
    <Helmet>
      <html color-scheme={colorScheme} />
    </Helmet>
  );
};

Head.displayName = "Head";
